import styles from './WorkspaceSelector.module.css';

const AVATAR_COLOR_CLASSES = [
  styles.avatarBlue,
  styles.avatarGreen,
  styles.avatarOrange,
  styles.avatarGrape,
] as const;

export function getAvatarColorClass(name: string): string {
  const index = name.charCodeAt(0) % AVATAR_COLOR_CLASSES.length;
  return AVATAR_COLOR_CLASSES[index] ?? '';
}
